import {useParams} from "react-router-dom";

import useDetailsAction from "../actions/details/useDetailsAction";
import {Badge, Button, Card} from "react-bootstrap";
import {t} from "i18next";
import {useEffect} from "react";
import GoBack from "@main/panel-components/GoBack";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";
import useEditObservationsAction
    from "@beeldit/ecommerce/super-orders/actions/edit-observations/useEditObservationsAction";
import useEditBillingAddressAction from "../actions/edit-billing-address/useEditBillingAddressAction";
import useEditShippingAddressAction from "../actions/edit-shipping-address/useEditShippingAddressAction";
import { Order } from "@beeldit/ecommerce/orders/models/Order";

function SuperOrderDetailPage(props: any) {
  const { filters, formDefaultValues } = props;

  let {orderId} = useParams();

  if (!orderId) {
    orderId = "0";
  }

  const {
    element,
    getFunction,
    actionTemplate
  } = useDetailsAction(parseInt(orderId));

  const onSuccess = () => {
     getFunction(element.id)
  }

  const { showModalObservations, actionTemplate: editObservationsTemplate  } = useEditObservationsAction(onSuccess)

  const { showModal: showBillingAddressModal, actionTemplate: billingAddressActionTemplate } = useEditBillingAddressAction(onSuccess);

  const { showModal: showShippingAddressModal, actionTemplate: shippingAddressActionTemplate } = useEditShippingAddressAction(onSuccess);

  useEffect(() => {
    if (!orderId ) return;
    getFunction(orderId);
  }, [orderId])

  const getBadgeType = () => {
    const st = element.lower_order_status ?? element.status;
  if (st === SuperOrder.PENDING_STATUS) {
      return 'warning'
  } else if (st === SuperOrder.PAYED_STATUS) {
        return 'success'
  } else if (st === SuperOrder.COMPLETED) {
        return 'success'
  } else if (st === SuperOrder.CANCELLED) {
        return 'danger'
    }
  };

  const noShippingStarted = (element: SuperOrder) => {
    // Recorremos todos los orders y vemos que el estado de ninguno de ellos sea mayor a 3 (In preparation)
    // Si es así, devolvemos true
    if (element.orders.length > 0) {
      for (let i = 0; i < element.orders.length; i++) {
        if (element.orders[i].status > Order.IN_PREPARATION) {
          return false;
        }
      }
      return true;
    }
  }
  return (
      <Card className="superorder">
        <Card.Header>
          <Card.Title>
            <GoBack />
            <span>{t("super_order")} {element?.reference}</span>
            <Badge bg={getBadgeType()}>{t("order_status_" + (element?.lower_order_status ?? element?.status))}</Badge>
          </Card.Title>
          <div className="header-actions">
            <Button
                variant="primary"
                onClick={() => showModalObservations(element)}
            >
                {t("edit_observations")}
            </Button>
            <Button
                variant="primary"
                onClick={() => showBillingAddressModal(element)}
            >
                {t("edit_billing_address")}
            </Button>

            {
              noShippingStarted(element) ? (<Button
                variant="primary"
                onClick={() => showShippingAddressModal(element)}
            >
                {t("edit_shipping_address")}
            </Button>) : null
            }            
          </div>
        </Card.Header>

        <Card.Body>
          {actionTemplate}
          {billingAddressActionTemplate}
          {editObservationsTemplate}
          {shippingAddressActionTemplate}
        </Card.Body>
      </Card>
  );
}

export default SuperOrderDetailPage;
